/* eslint-disable eqeqeq */
import { Mask } from "antd-mobile-v5";
import styled from "styled-components";
import { CloseOutline } from "antd-mobile-icons";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import VideoPlay from "../EnterpriseWechat/Material/component/VideoPlay";
import instance from "../../util/axios";
import { BaseURL } from "../../constant";
const VideoShowWrapper = styled.div`
  position: relative;
  .video-play-box {
    position: absolute;
    top: 0;
    left: 0;
    background: none;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    z-index: 2;
  }
  .video-play-icon {
    margin: 21px 0 0 5px;
  }
  .bottom-paging {
    text-align: center;
    position: fixed;
    bottom: 0;
    height: 44px;
    z-index: 99999;
    background: #fff;
    width: 100%;
    line-height: 44px;
    border-top: solid 1px rgba(0, 0, 0, 0.08);
  }
  .video-content-warp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .video-content {
    background: #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: calc(100vh);
    min-height: 210px;
  }

  .video-close-icon {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 99999;
    color: #fff;
    font-weight: bold;
    font-size: 28px;
    display: block;
  }

  .img-viewer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  /* .img-viewer .adm-image-viewer-image-wrapper {
	width: auto;
	height: auto;
  padding: 85px 60px 40px 60px;
} */
  .video-conten .video-react {
    position: unset;
  }

  .video-react .video-react-big-play-button {
    font-size: 3em;
    line-height: 55px;
    height: 55px;
    width: 55px;
    display: block;
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 0;
    cursor: pointer;
    opacity: 1;
    border: 0.06666em solid #fff;
    background-color: #2b333f;
    background-color: rgba(43, 51, 63, 0.7);
    border-radius: 100%;
    transition: all 0.4s;
  }
  .video-react .video-react-big-play-button.video-react-big-play-button-center {
    top: 50%;
    left: 50%;
    margin-top: -27.5px;
    margin-left: -27.5px;
  }
  .video-react .video-react-big-play-button.big-play-button-hide {
    display: none;
  }
  .video-react:hover .video-react-big-play-button,
  .video-react .video-react-big-play-button:focus {
    outline: 0;
    border-color: #fff;
    background-color: #73859f;
    background-color: rgba(115, 133, 159, 0.5);
    -webkit-transition: all 0s;
    -moz-transition: all 0s;
    -o-transition: all 0s;
    transition: all 0s;
  }

  .empty-box .adm-empty-description {
    font-size: 16px;
    color: #333;
    margin-top: 30px;
  }
  .empty-box .adm-empty-image-container .adm-empty-image {
    width: 120px;
    height: 105px;
  }
`;
const VideoShow = () => {
  const [src, setSrc] = useState("");
  const playRef = useRef<any>(null);
  const params = useParams<{
    videoId: string;
    width: any;
    height: any;
  }>();

  useEffect(() => {
    setSrc(decodeURIComponent(params.videoId));
  }, [params]);

  return (
    <VideoShowWrapper>
      <Mask
        visible={true}
        destroyOnClose
        onMaskClick={(e) => {
          e.stopPropagation();
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.postMessage("/closeWebView");
        }}
        className="video-content-warp"
      >
        <div className="video-content">
          <CloseOutline
            className="video-close-icon"
            onClick={(e) => {
              e.stopPropagation();
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              window.postMessage("/closeWebView");
            }}
          />
          <VideoPlay
            src={src}
            width={params?.width}
            height={params?.height}
            ref={playRef}
          />
        </div>
      </Mask>
    </VideoShowWrapper>
  );
};
export default VideoShow;
